// ─── DAZZLE MONTREAL — COMPLETE JS ───────────────────────────────────────


// ── TOAST NOTIFICATION ──
function dzToast(msg, type){
  var t = document.getElementById('dz-toast');
  if(!t){
    t = document.createElement('div');
    t.id = 'dz-toast';
    t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 20px;border-radius:4px;font-size:12px;font-weight:700;letter-spacing:.05em;z-index:2000;opacity:0;transition:opacity .25s;pointer-events:none;white-space:nowrap;max-width:90vw;text-align:center';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.background = type === 'error' ? '#c0392b' : type === 'success' ? '#27ae60' : '#111';
  t.style.opacity = '1';
  clearTimeout(t._timer);
  t._timer = setTimeout(function(){ t.style.opacity = '0'; }, 3000);
}

// ── MONEY FORMAT (uses shop.money_format injected via theme.liquid) ──
function dzMoney(cents){
  var fmt = window.dzMoneyFmt || '${{amount}}';
  var n = (cents / 100).toFixed(2);
  var parts = n.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  var formatted = parts.join('.');
  return fmt.replace('{{amount}}', formatted)
            .replace('{{amount_no_decimals}}', Math.round(cents/100))
            .replace('{{amount_with_comma_separator}}', formatted.replace('.',','));
}

function dzInitSlider(){}

// ── WARRANTY + PACKAGE PROTECTION (offered at the checkout step, never stored in the cart) ──
var DZ_PROTECTION_VARIANT = 45724902359123;
var DZ_PROTECTION_PRICE = 499; // cents

/* Find the protection line item in a cart object (by variant id) */
function dzFindProtection(cart){
  var found = null;
  cart.items.forEach(function(it){ if(it.variant_id === DZ_PROTECTION_VARIANT) found = it; });
  return found;
}

/* Checkout WITH protection: add the add-on, then go straight to checkout */
function dzProtectedCheckout(btn){
  if(btn){ btn.style.opacity = '.6'; btn.style.pointerEvents = 'none'; }
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: DZ_PROTECTION_VARIANT, quantity: 1})})
  .then(function(){ window.location.href = '/checkout'; })
  .catch(function(){ window.location.href = '/checkout'; });
}

/* Checkout WITHOUT protection */
function dzPlainCheckout(){ window.location.href = '/checkout'; }

// ── CART DRAWER ──
function dzCart(){
  var d = document.getElementById('dz-cart-drawer');
  var o = document.getElementById('dz-cart-ov');
  if(!d) return;
  var opening = !d.classList.contains('open');
  d.classList.toggle('open');
  if(o) o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
  if(opening) dzRefreshCartDrawer();
}

// ── REFRESH CART DRAWER ──
function dzRefreshCartDrawer(cart){
  /* If a fresh cart object is passed (e.g. from a /cart/change.js or /cart/add.js response),
     render from it directly — no GET, so iOS Safari caching can never serve a stale cart. */
  if(cart){ dzRenderCartDrawer(cart); return; }
  /* Otherwise fetch it. Cache-bust + no-store to defeat iOS Safari caching of /cart.js. */
  fetch('/cart.js?_=' + Date.now(), {cache:'no-store'})
    .then(function(r){ return r.json(); })
    .then(dzRenderCartDrawer);
}
function dzRenderCartDrawer(cart){
    /* Protection is only ever added at the final checkout click and never kept in the cart view.
       If the shopper navigated back from checkout, strip the stray add-on and re-render. */
    var stray = dzFindProtection(cart);
    if(stray){
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: stray.key, quantity: 0})})
      .then(function(r){ return r.json(); })
      .then(dzRenderCartDrawer);
      return;
    }

    /* Scope all queries to the cart drawer. The wishlist drawer reuses .cart-items / .cart-title
       and sits earlier in the DOM, so an unscoped querySelector would hit the wishlist by mistake. */
    var root = document.getElementById('dz-cart-drawer');
    if(!root) return;

    var realItems = cart.items;
    var realCount = cart.item_count;

    // Update badge (in the header, unique id)
    var badge = document.getElementById('dz-cart-count');
    if(badge) badge.textContent = realCount;

    // Update item count in title
    var titleSpan = root.querySelector('.cart-title span');
    if(titleSpan) titleSpan.textContent = '(' + realCount + ')';

    // Update the "Protected Checkout" button total (subtotal + protection fee)
    var protTotalEl = document.getElementById('dz-prot-total');
    if(protTotalEl) protTotalEl.textContent = dzMoney(cart.total_price + DZ_PROTECTION_PRICE);

    // Update shipping bar
    var thresh = window.dzFreeShipThresh || 7500;
    var pct = Math.min(100, Math.round(cart.total_price / thresh * 100));
    var fill = root.querySelector('.ship-fill');
    var msg  = root.querySelector('.ship-msg');
    if(fill) fill.style.width = pct + '%';
    if(msg){
      if(cart.total_price >= thresh){
        msg.innerHTML = '<strong style="color:#27ae60">You unlocked FREE shipping! &#128666;</strong>';
      } else {
        var rem = dzMoney(thresh - cart.total_price);
        msg.innerHTML = 'Add <strong>' + rem + '</strong> more for <strong>FREE shipping!</strong>';
      }
    }

    // Update total
    var total = root.querySelector('.cart-total-row strong');
    if(total) total.textContent = dzMoney(cart.total_price);

    // Rebuild cart items
    var itemsEl = root.querySelector('.cart-items');
    if(!itemsEl) return;
    if(realCount === 0){
      itemsEl.innerHTML = '<div style="text-align:center;padding:48px 20px;color:#888;font-size:14px">Your cart is empty</div>';
      return;
    }

    /* Group same-variant lines for display: B2G1 splits a variant into paid + free lines, so combine
       all PAID units of a variant into one row and all FREE units into one row. */
    var groups = dzGroupCartItems(realItems);

    var html = '';
    groups.forEach(function(g){
      var item = g.sample;
      var imgStyle = item.image
        ? 'background:url(' + encodeURI(item.image) + ') center/cover no-repeat,#f5f5f5'
        : 'background:linear-gradient(160deg,#FFDCE5,#DDF2FF)';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="ci-var">' + item.variant_title + '</div>' : '';
      var priceHtml;
      if(g.free){
        priceHtml = '<div class="ci-price"><span class="ci-was">' + dzMoney(g.orig) + '</span> <span class="ci-free">FREE</span></div>';
      } else if(g.fin < g.orig){
        priceHtml = '<div class="ci-price"><span class="ci-was">' + dzMoney(g.orig) + '</span> ' + dzMoney(g.fin) + '</div>';
      } else {
        priceHtml = '<div class="ci-price">' + dzMoney(g.fin) + '</div>';
      }
      var url = (item.url || '#').replace(/"/g,'&quot;');
      var name = (item.product_title||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      var controls = '<div class="ci-qty">' +
          '<button onclick="dzGrpDown(\'' + g.firstKey + '\',' + g.firstQty + ',' + g.qty + ')">&#8722;</button>' +
          '<span>' + g.qty + '</span>' +
          '<button onclick="dzGrpUp(' + g.variantId + ')">&#43;</button>' +
        '</div>';
      var removeBtn = '<span class="ci-remove" onclick="dzGrpRemove(\'' + g.keys.join(',') + '\')">Remove</span>';
      html += '<div class="ci">' +
        '<a class="ci-img" href="' + url + '"><div class="bg" style="' + imgStyle + ';width:100%;height:100%"></div></a>' +
        '<div class="ci-info">' +
          '<a class="ci-name" href="' + url + '">' + name + '</a>' +
          variantLine +
          '<div class="ci-row">' + controls + priceHtml + '</div>' +
          removeBtn +
        '</div>' +
      '</div>';
    });
    itemsEl.innerHTML = html;
}

/* Combine cart line items by variant + free/paid (B2G1 splits a variant across several lines). */
function dzGroupCartItems(items){
  var groups = [], map = {};
  items.forEach(function(it){
    var free = (it.final_line_price === 0 && it.original_line_price > 0);
    var k = it.variant_id + '|' + (free ? 'F' : 'P');
    if(!map[k]){
      map[k] = { free:free, variantId:it.variant_id, qty:0, orig:0, fin:0, sample:it, firstKey:it.key, firstQty:it.quantity, keys:[] };
      groups.push(map[k]);
    }
    var g = map[k];
    g.qty += it.quantity; g.orig += it.original_line_price; g.fin += it.final_line_price; g.keys.push(it.key);
  });
  return groups;
}

// ── ADD TO CART (from grids / quick-add) ──
function dzAddToCart(id, qty, btn){
  qty = qty || 1;
  var orig = btn ? btn.textContent : null;
  if(btn){ btn.textContent = 'Adding...'; btn.style.opacity = '.7'; }
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: id, quantity: qty})})
  .then(function(r){ return r.json(); })
  /* /cart/add.js only returns the added line — POST /cart/update.js (no changes) to get the FULL
     fresh cart back, so we render from a POST response and never hit the cacheable /cart.js GET. */
  .then(function(){
    return fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({updates: {}})}).then(function(r){ return r.json(); });
  })
  .then(function(cart){
    if(btn){ btn.textContent = 'Added!'; btn.style.opacity = '1';
      setTimeout(function(){ btn.textContent = orig; }, 1800); }
    dzRefreshCartDrawer(cart); // render from the POST response — no stale GET
    // Open the drawer if closed, without triggering another refresh/GET
    var d = document.getElementById('dz-cart-drawer'), o = document.getElementById('dz-cart-ov');
    if(d && !d.classList.contains('open')){
      d.classList.add('open'); if(o) o.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }).catch(function(err){
    console.error('Add to cart failed:', err);
    if(btn){ btn.textContent = orig || 'Add to Cart'; btn.style.opacity = '1'; }
    dzToast('Could not add to cart. Please try again.', 'error');
  });
}

// ── DEBOUNCE HELPER ──
function dzDebounce(fn, delay){
  var timer;
  return function(){
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function(){ fn.apply(null, args); }, delay);
  };
}
var dzChangeQtyDebounced = null;

// ── QTY DOWN (with remove guard) ──
function dzQtyDown(key, current){
  if(current <= 1){
    if(!confirm('Remove this item?\nRetirer cet article?')) return;
  }
  dzChangeQty(key, current - 1);
}

// ── CHANGE QTY IN CART ──
function dzChangeQty(key, qty){
  /* Runs immediately — debounce happens at the call site via dzQtyDown/up */
  /* Find the button/element that triggered this and show loading state */
  fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: qty})})
  .then(function(r){
    if(!r.ok) throw new Error('Cart error: ' + r.status);
    return r.json();
  })
  .then(function(cart){
    dzRefreshCartDrawer(cart); // render from the fresh cart this POST returned — no stale GET
    var badge = document.getElementById('dz-cart-count');
    if(badge) badge.textContent = cart.item_count;
  })
  .catch(function(err){
    console.error('dzChangeQty failed:', err);
    dzRefreshCartDrawer();
  })
  .finally(function(){
    /* Re-enable buttons after response */
    document.querySelectorAll('.ci-qty button, .ci-remove').forEach(function(b){ b.style.opacity=''; b.style.pointerEvents=''; });
  });
}

// ── FULL CART PAGE qty (server-rendered list — reload to re-render totals/shipping bar correctly) ──
function dzCartQty(key, qty){
  document.querySelectorAll('.dz-ci .ci-qty button, .dz-ci-remove').forEach(function(b){ b.style.opacity='.5'; b.style.pointerEvents='none'; });
  fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: qty})})
  .then(function(r){ if(!r.ok) throw new Error('Cart error: ' + r.status); return r.json(); })
  .then(function(){ window.location.reload(); })
  .catch(function(err){ console.error('dzCartQty failed:', err); window.location.reload(); });
}
function dzCartQtyDown(key, current){
  if(current <= 1){ if(!confirm('Remove this item?\nRetirer cet article?')) return; }
  dzCartQty(key, current - 1);
}

// ── GROUPED qty controls (combined same-variant rows) ──
function dzSeqRemove(keys, done){
  (function next(i){
    if(i >= keys.length){ done(); return; }
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: keys[i], quantity: 0})})
    .then(function(r){ return r.json(); })
    .then(function(){ next(i + 1); })
    .catch(function(){ next(i + 1); });
  })(0);
}
function dzAddVariant(variantId){
  return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})})
    .then(function(){ return fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({updates: {}})}); })
    .then(function(r){ return r.json(); });
}
/* Cart DRAWER (re-render in place) */
window.dzGrpUp = function(variantId){ dzAddVariant(variantId).then(dzRefreshCartDrawer); };
window.dzGrpDown = function(firstKey, firstQty, groupQty){
  if(groupQty <= 1){ if(!confirm('Remove this item?\nRetirer cet article?')) return; }
  dzChangeQty(firstKey, firstQty - 1);
};
window.dzGrpRemove = function(keysCSV){ dzSeqRemove(keysCSV.split(','), function(){ dzRefreshCartDrawer(); }); };
/* Cart PAGE (reload) */
window.dzCartGrpUp = function(variantId){ dzAddVariant(variantId).then(function(){ window.location.reload(); }); };
window.dzCartGrpDown = function(firstKey, firstQty, groupQty){
  if(groupQty <= 1){ if(!confirm('Remove this item?\nRetirer cet article?')) return; }
  dzCartQty(firstKey, firstQty - 1);
};
window.dzCartGrpRemove = function(keysCSV){ dzSeqRemove(keysCSV.split(','), function(){ window.location.reload(); }); };

// ── MOBILE MENU ──
function dzMenu(){
  var d = document.getElementById('dz-mob-drawer');
  var o = document.getElementById('dz-mob-ov');
  if(!d) return;
  d.classList.toggle('open');
  if(o) o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
}
function dzSub(el){
  el.classList.toggle('expanded');
  var s = el.nextElementSibling;
  if(s && s.classList.contains('md-sub')) s.classList.toggle('open');
}

// ── RESET BODY OVERFLOW ON NAV ──
window.addEventListener('pagehide', function(){ document.body.style.overflow = ''; });

// ── HEADER SCROLL SHADOW ──
window.addEventListener('scroll', function(){
  var h = document.querySelector('.header');
  if(h) h.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,.08)' : 'none';
});

// ── EMAIL POPUP ──
setTimeout(function(){
  var p = document.getElementById('dz-popup');
  if(!p) return;
  var shown = localStorage.getItem('dz_popup_shown');
  var now = Date.now();
  var reshowInterval = 30 * 60 * 1000; /* re-show 30 minutes after it was last shown */
  var shownTime = parseInt(shown);
  /* Validate it's a real timestamp (after 2020) not legacy '1' value */
  var validTimestamp = shownTime > 1577836800000;
  if(!shown || !validTimestamp || (now - shownTime) > reshowInterval){
    p.classList.add('open');
    localStorage.setItem('dz_popup_shown', String(now));
  }
}, (window.dzPopupDelay || 30) * 1000);

// ── ACCORDION ──
document.addEventListener('click', function(e){
  var head = e.target.closest('.acc-head');
  if(head) head.parentElement.classList.toggle('open');
});


// ── WISHLIST (global — grid cards) ──
var DZ_WISH_KEY = 'dz_wishlist';
function dzWishRaw(){ try{ return JSON.parse(localStorage.getItem(DZ_WISH_KEY)||'[]'); }catch(e){ return []; } }
/* Normalize: legacy entries are plain numeric ids; new entries are {id, handle} */
function dzWishList(){ return dzWishRaw().map(function(it){ return (it && typeof it === 'object') ? it : { id: it, handle: '' }; }); }
function dzWishSave(list){ try{ localStorage.setItem(DZ_WISH_KEY, JSON.stringify(list)); }catch(e){} }
function dzWishHas(id){ id = parseInt(id); return dzWishList().some(function(it){ return parseInt(it.id) === id; }); }
function dzWishCount(){ return dzWishList().length; }
function dzWishToggle(id, handle){
  id = parseInt(id);
  var list = dzWishList(), idx = -1;
  for(var i=0;i<list.length;i++){ if(parseInt(list[i].id) === id){ idx = i; break; } }
  var added;
  if(idx === -1){ list.push({ id: id, handle: handle || '' }); added = true; }
  else { list.splice(idx,1); added = false; }
  dzWishSave(list); dzUpdateWishBadge();
  return added;
}
function dzUpdateWishBadge(){
  var n = dzWishCount();
  var badge = document.getElementById('dz-wish-count');
  if(badge){ badge.textContent = n; badge.style.display = n > 0 ? 'flex' : 'none'; }
  var tc = document.getElementById('dz-wish-title-count');
  if(tc) tc.textContent = '(' + n + ')';
}
/* Expose for the inline PDP wishlist script */
window.dzWishToggle = dzWishToggle;
window.dzWishHas = dzWishHas;

/* Heart toggle on product cards */
function dzToggleWishCard(el, productId){
  var added = dzWishToggle(productId, el.dataset.handle);
  el.innerHTML = added ? '&#9829;' : '&#9825;';
  el.style.color = added ? '#c8427a' : '';
  el.style.background = added ? 'rgba(200,66,122,.12)' : '';
}

/* ── WISHLIST DRAWER ── */
function dzWishOpen(){
  var d = document.getElementById('dz-wish-drawer'), o = document.getElementById('dz-wish-ov');
  if(!d) return;
  d.classList.add('open'); if(o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
  dzWishRender();
}
function dzWishClose(){
  var d = document.getElementById('dz-wish-drawer'), o = document.getElementById('dz-wish-ov');
  if(d) d.classList.remove('open'); if(o) o.classList.remove('open');
  document.body.style.overflow = '';
}
window.dzWishOpen = dzWishOpen;
window.dzWishClose = dzWishClose;

function dzWishRemoveId(id){
  id = parseInt(id);
  dzWishSave(dzWishList().filter(function(it){ return parseInt(it.id) !== id; }));
  dzUpdateWishBadge();
}
window.dzWishRemove = function(id){
  dzWishRemoveId(id);
  document.querySelectorAll('.wish[data-product-id="' + id + '"]').forEach(function(w){
    w.innerHTML = '&#9825;'; w.style.color = ''; w.style.background = '';
  });
  dzWishRender();
};

function dzWishRender(){
  var wrap = document.getElementById('dz-wish-items');
  if(!wrap) return;
  var list = dzWishList().filter(function(it){ return it.handle; });
  var emptyHtml = '<div style="text-align:center;padding:48px 20px;color:#888;font-size:14px">Your wishlist is empty.<br><span style="font-size:12px">Tap the &#9825; on any product to save it here.</span></div>';
  if(!list.length){ wrap.innerHTML = emptyHtml; return; }
  wrap.innerHTML = '<div style="text-align:center;padding:32px 20px;color:#888;font-size:13px">Loading&hellip;</div>';
  Promise.all(list.map(function(it){
    return fetch('/products/' + it.handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  })).then(function(products){
    var html = '';
    products.forEach(function(p){
      if(!p) return;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var v = (p.variants || []).filter(function(x){ return x.available; })[0] || (p.variants || [])[0];
      var name = (p.title||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      var addBtn = v ? '<button class="dz-wish-add" onclick="dzAddToCart(' + v.id + ',1,this)">+ Add to Cart</button>'
                     : '<span style="font-size:11px;color:#aaa">Sold out</span>';
      html += '<div class="ci">' +
        '<a class="ci-img" href="/products/' + p.handle + '"><div class="bg" style="background:url(' + encodeURI(img) + ') center/cover no-repeat,#f5f5f5;width:100%;height:100%"></div></a>' +
        '<div class="ci-info">' +
          '<a class="ci-name" href="/products/' + p.handle + '">' + name + '</a>' +
          '<div class="ci-price">' + dzMoney(p.price) + '</div>' +
          '<div class="dz-wish-row">' + addBtn +
            '<span class="ci-remove" onclick="dzWishRemove(' + p.id + ')">Remove</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    wrap.innerHTML = html || emptyHtml;
  });
}

// ── SEARCH ICON → navigate to search ──
document.addEventListener('DOMContentLoaded', function(){
  // Close mobile drawer when any link inside it is clicked
  var drawer = document.getElementById('dz-mob-drawer');
  if(drawer){
    drawer.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        var d = document.getElementById('dz-mob-drawer');
        var o = document.getElementById('dz-mob-ov');
        if(d && d.classList.contains('open')){
          d.classList.remove('open');
          if(o) o.classList.remove('open');
          document.body.style.overflow = '';
        }
      });
    });
  }

  dzInitSlider();

  // Close popup when clicking overlay
  var popupOv = document.getElementById('dz-popup');
  if(popupOv){
    popupOv.addEventListener('click', function(e){
      if(e.target === popupOv) popupOv.classList.remove('open');
    });
  }

  // Wire up search icon if it's a div not an <a>
  var searchHico = document.querySelector('.hico[title="Search"]');
  if(searchHico && searchHico.tagName !== 'A'){
    searchHico.style.cursor = 'pointer';
    searchHico.addEventListener('click', function(){ window.location = '/search'; });
  }

  // Wishlist heart on product cards — persists via localStorage
  document.addEventListener('click', function(e){
    var wish = e.target.closest('.wish');
    if(!wish) return;
    e.preventDefault();
    var pid = parseInt(wish.dataset.productId || '0');
    if(pid) dzToggleWishCard(wish, pid);
    else {
      // Fallback: just toggle visual if no product ID
      var filled = wish.innerHTML.indexOf('9829') !== -1;
      wish.innerHTML = filled ? '&#9825;' : '&#9829;';
      wish.style.color = filled ? '' : '#c8427a';
    }
  });
  // Init wishlist state on page load
  var wishCards = document.querySelectorAll('.wish[data-product-id]');
  wishCards.forEach(function(w){
    var pid = parseInt(w.dataset.productId||'0');
    if(pid && dzWishHas(pid)){
      w.innerHTML = '&#9829;';
      w.style.color = '#c8427a';
      w.style.background = 'rgba(200,66,122,.12)';
    }
  });
  dzUpdateWishBadge();
});
